/**
 * I am a flag stored in localStorage
 * I'll be set for a period of time, and then I won't
 */
export class CoolDownFlag {
	constructor(key, period) {
		this.key = key
		this.period = period
	}

	isSet() {
		const timestamp = localStorage.getItem(this.key)
		if (!!!timestamp) {
			return false
		}

		const now = Date.now()
		return (now - timestamp) < this.period
	}

	set() {
		localStorage.setItem(this.key, Date.now())
	}
}